/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankIdLoginPayloadRequest
 */
export interface BankIdLoginPayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginPayloadRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginPayloadRequest
     */
    redirectUri: string;
}

/**
 * Check if a given object implements the BankIdLoginPayloadRequest interface.
 */
export function instanceOfBankIdLoginPayloadRequest(value: object): value is BankIdLoginPayloadRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('redirectUri' in value) || value['redirectUri'] === undefined) return false;
    return true;
}

export function BankIdLoginPayloadRequestFromJSON(json: any): BankIdLoginPayloadRequest {
    return BankIdLoginPayloadRequestFromJSONTyped(json, false);
}

export function BankIdLoginPayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankIdLoginPayloadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'redirectUri': json['redirect_uri'],
    };
}

export function BankIdLoginPayloadRequestToJSON(json: any): BankIdLoginPayloadRequest {
    return BankIdLoginPayloadRequestToJSONTyped(json, false);
}

export function BankIdLoginPayloadRequestToJSONTyped(value?: BankIdLoginPayloadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'redirect_uri': value['redirectUri'],
    };
}

